import {Component, OnInit} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { InputType, InputComponent } from '../../form/input/input.component';
import { ButtonDirective } from 'primeng/button';

import { TagModule } from 'primeng/tag';

@Component({
    selector: 'app-generic-input-dialog',
    templateUrl: './generic-input-dialog.component.html',
    styleUrls: ['./generic-input-dialog.component.scss'],
    imports: [InputComponent, ButtonDirective, TagModule]
})
export class GenericInputDialogComponent implements OnInit {

    constructor(
        private dynamicDialogRef: DynamicDialogRef, private config: DynamicDialogConfig
    ) {
        const configuration = config.data as GenericInputDialogConfiguration;
        this.inputType = configuration.inputType ?? 'text';
        this.maxLength = configuration.maxLength === 0 ? undefined : (configuration.maxLength ?? 255);
        this.showLength = configuration.maxLength === 0 ? false : (configuration.showLength ?? true);
        this.message = configuration.message ?? '';
        this.placeholder = configuration.placeholder ?? '';

        this.cancelLabel = configuration.cancelLabel ?? 'Annulla';
        this.cancelIcon = configuration.cancelIcon ?? 'pi pi-times';
        this.confirmLabel = configuration.confirmLabel ?? 'Conferma';
        this.confirmIcon = configuration.confirmIcon ?? 'pi pi-save';
        this.inputWidth = configuration.inputWidth;

        if (configuration.value) {
            this.value = configuration.value;
        }

    }

    inputType: InputType;
    value: string;
    maxLength: number;
    showLength: boolean;
    message: string;
    placeholder: string;
    confirmLabel: string;
    confirmIcon: string;
    cancelLabel: string;
    cancelIcon: string;
    inputWidth: string;

    ngOnInit(): void {
    }

    confirm() {
        const fallbackValue = this.inputType === 'number' ? NaN : '';
        this.dynamicDialogRef.close(this.value ?? fallbackValue);
    }

    close() {
        this.dynamicDialogRef.close(null);
    }

    static openDialog(dialogService: DialogService, data: GenericInputDialogConfiguration): DynamicDialogRef {
        let width = '60%';
        switch (data.width) {
            case 'small':
                width = '30%';
                break;
            case 'medium':
                width = '50%';
                break;
            case 'large':
                width = '90%';
                break;
        }


        return dialogService.open(GenericInputDialogComponent,
            {
                width: width ?? '60%',
                closable: true,
                closeOnEscape: true,
                header: data.title ?? 'Quesito',
                modal: true,
                showHeader: true,
                data: data,
            }
        );
    }

}

export interface GenericInputDialogConfiguration {
    title: string;
    width: string | 'small' | 'medium' | 'large';

    message: string;
    placeholder: string;
    maxLength?: number;
    showLength: boolean;
    inputType: InputType;
    cancelLabel?: string;
    cancelIcon?: string;
    confirmLabel?: string;
    confirmIcon?: string;
    inputWidth?: string;

    value?: string;
}
